import { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";

// import MaterialTable from "material-table";
import { Button } from "@mantine/core";
import { Calendar, DateInput } from "@mantine/dates";
// import Chart_Bar_CafePOS_HeatMap_Daily from "../Chart/Chart_Bar_CafePOS_HeatMap_Daily";
// import Chart_Bar_CafePOS_HourlyADay from "../Chart/Chart_Bar_CafePOS_HeatMap_HourlyADay";
import Chart_Bar_CafePOS_3_1_3 from "../Chart/Chart_Bar_CafePOS_3_1_3";

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const Comp_Cafe_POS_HeatMap_Monthly = ({ selectedPresentationCafe }) => {
  const [DB_CafePCList, setDB_CafePCList] = useState([]);
  const get_DB_CafePCList_ByCafe = async (cafe) => {
    setLoadTask1(0);
    console.log("load task 1 start");

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/get_eclipse_pos_cafepc_customlist`, {
        cafe,
      })
      .then((res) => {
        console.log("get_DB_CafePCList_ByCafe", res?.data);

        setDB_CafePCList(res?.data);
        setLoadTask1(1);
        // console.log("load task 1 done");
      });
  };

  //----------------------------------- global variable
  //   const [selectedPresentationCafe, setSelectedPresentationCafe] = useState(
  //     _selectedPresentationCafe
  //   );
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const [load_1, setLoad_1] = useState(true);
  const [load_2, setLoad_2] = useState(false);
  const [load_3, setLoad_3] = useState(false);
  const [load_4, setLoad_4] = useState(false);
  const [load_5, setLoad_5] = useState(false);

  const [loadTask1, setLoadTask1] = useState(1);
  const [loadTask2, setLoadTask2] = useState(0);

  const [selectedPresentationMode, setSelectedPresentationMode] = useState("");
  const [calenderValue, setCalenderValue] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  //----------------------------------- function
  function forwardOneYear() {
    setCalenderValue((prev) => dayjs(prev).add(1, "year").toDate());
    setSelectedDay((prev) => dayjs(prev).add(1, "year").format("YYYY-MM-DD"));
  }

  function backOneYear() {
    setCalenderValue((prev) => dayjs(prev).subtract(1, "year").toDate());
    setSelectedDay((prev) =>
      dayjs(prev).subtract(1, "year").format("YYYY-MM-DD")
    );
  }

  function getDaysInMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed

    // Get the number of days in the month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Create array of days ['1', '2', ..., '31']
    const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
      (i + 1).toString()
    );

    return daysArray;
  }

  const COMP_ShowAllMonthInYear = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",

            // backgroundColor: stringToColor(pczoneSelected),
            gap: 10,
          }}
        >
          <div
            style={{
              width: "80px",
              minWidth: "80px",
              fontSize: 10,
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              marginLeft: 10,
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              width: "120px",
              minWidth: "120px",
              fontSize: 15,
              textAlign: "right",
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 0,
              width: "1400px",
              minWidth: "1400px",
            }}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map((x, i) => {
              return (
                <div
                  key={i}
                  style={{
                    marginLeft: "0.1rem",
                    marginBottom: "0.1rem",
                    backgroundColor: "white",
                    color: "black",
                    width: "70px",
                  }}
                >
                  <div>{x}</div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <div>3.1. Group By PC (measure by time)</div>
      <h2>3.1.3. Monthly </h2>

      <div
        style={{
          backgroundColor: "white",
          padding: "1rem",
          borderRadius: "1rem",
          // position: "sticky",
          // top: 35,
          // zIndex: 10,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <Button
            disabled={loadTask1 == 0}
            color="dark"
            onClick={() => {
              backOneYear();
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Previous Year
          </Button>
          <Button
            disabled={loadTask1 == 0}
            color="dark"
            onClick={() => {
              forwardOneYear();
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Next Year
          </Button>
          <div style={{ color: "black" }}>
            <b>Pick a Year</b>
          </div>
          <div>
            <DateInput
              clearable={false}
              disabled={loadTask1 == 0}
              value={calenderValue}
              onChange={(e) => {
                setSelectedDay(dayjs(e).format("YYYY-MM-DD"));
                return setCalenderValue(e);
              }}
            />
          </div>
          <Button
            color="lime"
            onClick={() => {
              get_DB_CafePCList_ByCafe(selectedPresentationCafe);
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Check Monthly This Year
          </Button>
          {/* <div
                            style={{ color: "black" }}
                          >{`selectedDay:${selectedDay}`}</div> */}
          <div style={{ color: "black" }}>
            {`Total PCs : ${DB_CafePCList?.length}, cafe : ${selectedPresentationCafe},`}
          </div>
          <div style={{ color: "black" }}>
            {loadTask1 == 0 ? (
              <div style={{ color: "orange" }}>Loading...</div>
            ) : (
              <div style={{ color: "green" }}>
                {`Data Loaded = ${loadTask1 * 100}%`}
              </div>
            )}
          </div>
        </div>
      </div>
      <br />
      {DB_CafePCList?.length > 0 ? (
        <>
          <Button
            variant={showMoreInfo ? "filled" : "subtle"}
            color="lime"
            onClick={() => {
              setShowMoreInfo(!showMoreInfo);
            }}
          >
            Show Extra Info
          </Button>

          <br />
          <br />
          {/* list all days in this month  */}
          <COMP_ShowAllMonthInYear />
          {load_1 == true ? (
            DB_CafePCList?.slice(0, 30)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_1_3
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pcRemarkSelected={x?.pc_name_remark_n}
                  pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_1 == true}
              onClick={() => {
                setLoad_1(true);
              }}
            >
              Load part 1
            </Button>
          )}
          {load_2 == true ? (
            DB_CafePCList?.slice(30, 60)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_1_3
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pcRemarkSelected={x?.pc_name_remark_n}
                  pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_2 == true}
              onClick={() => {
                setLoad_2(true);
              }}
            >
              Load part 2
            </Button>
          )}
          {load_3 == true ? (
            DB_CafePCList?.slice(60, 90)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_1_3
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pcRemarkSelected={x?.pc_name_remark_n}
                  pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_3 == true}
              onClick={() => {
                setLoad_3(true);
              }}
            >
              Load part 3
            </Button>
          )}
          {load_4 == true ? (
            DB_CafePCList?.slice(90, 120)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_1_3
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pcRemarkSelected={x?.pc_name_remark_n}
                  pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_4 == true}
              onClick={() => {
                setLoad_4(true);
              }}
            >
              Load part 4
            </Button>
          )}
          {load_5 == true ? (
            DB_CafePCList?.slice(120, 150)?.map((x, i) => {
              return (
                <Chart_Bar_CafePOS_3_1_3
                  key={i}
                  // icon={<IconCalendar size={16} />}
                  dateSelected={selectedDay}
                  cafeSelected={selectedPresentationCafe}
                  pcSelected={x?.zjm}
                  pcRemarkSelected={x?.pc_name_remark_n}
                  pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
                  showMoreInfo={showMoreInfo}
                />
              );
            })
          ) : (
            <Button
              fullWidth
              variant="subtle"
              color="lime"
              disabled={load_5 == true}
              onClick={() => {
                setLoad_5(true);
              }}
            >
              Load part 5
            </Button>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Comp_Cafe_POS_HeatMap_Monthly;
